<template>
  <div>

    <v-row
      justify="center"
      class="mt-5 graphContent"
      style="margin: 0px; margin-bottom: -18px"
    >
      <DailyReportFilter @handleFilter="handleFilter" @exportsToExcel="exportsToExcel" />
    </v-row>

    <div v-if="!this.$store.state.loadingData" class="requests-chart-classification">
      <table-component
        :showSelect="false"
        itemKey="id"
        :headers="headers"
        :pagination="this.$store.state.pagination"
        :limit="$store.state.counterOfShow"
        :items="this.$store.state.tableData"
        :loading="loading"
        @refresh="getTableData"
        v-model="page"
        :requestSourceData="requestSourceData"
      >
      </table-component>
    </div>
    <div class="loadingMore" v-else>
      <LoadingMore />
    </div>

     <!-- chart -->
     <div style="box-shadow: 0 0 0 0 !important" class="adminGraph">
      <div v-if="!getDataDone">
        <div style="margin-top: 40px" v-if="!loading">
          <highcharts :options="chartOptions" style="height: 600px"></highcharts>
        </div>
      </div>
      <div v-else class="loader">
        <img src="../../../../assets/Comp-2.gif" />
      </div>
    </div>

  </div>
</template>

<style lang="scss">
.loadingMore {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
}
</style>

<script>
import Axios from "axios";
// import LatestReportFilter from "./LatestReportFilter.vue";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts-vue";
import DailyReportFilter from "../../Charts/DailyReportFilter.vue";

export default {
  name: "AdminLatestReport",
  components: {/*LatestReportFilter,*/highcharts: Chart,DailyReportFilter},

  data() {
    return {
      page: 1,
      body: {},
      requestSourceData:{},
      loading: false,
      copySupportRequests: [],
      loadMoreData: false,
      loadingData: false,
      selected_requests: [],
      iconToggle: false,
      headers: [
        { text: "استشاري المبيعات", value: "استشاري المبيعات" },
        { text: "سرعة الاتصال بعد طلب الخدمة", value: "سرعة الاتصال بعد طلب الخدمة" },
        { text: "تقديم الحسبة المبدئية للعميل", value: "تقديم الحسبة المبدئية للعميل" },
        { text: "المتابعة مع العميل", value: "المتابعة مع العميل" },
        { text: "صحة ملاحظة الاستشاري", value: "صحة ملاحظة الاستشاري" },
        { text: "النتيجة النهائية", value: "النتيجة النهائية" }, 
      ],
      horizontalData: [],
      verticalData: [],

      chartData: [],
      getDataDone: false,
      chartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: "(النتيجة النهائية) نتائج تقييم الجودة",
        },
        xAxis: {
          min: 0,
          title: {
            text: "نتائج تقييم الجودة",
          },
          categories: [],
        },
        yAxis: {
          title: {
            text: "النتيجة النهائية",
          },
        },
        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
          shared: true,
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [
          {
            name: "النتيجة النهائية",
            data: [],
            color: "#FF0000",
          },
        ],
      },
    };
  },

  watch: {
    page(val) {
      this.getTableData(val);
    },

    selected_requests(val) {
      this.selectedItems = val;
      this.$emit("requests", val);
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval !== oldvalue && !this.$store.state.admin_search_active) {
          this.getTableData(this.page);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },

  },

  methods: {
    handleFilter(val) {
      this.body = new FormData();
      if (val.startDate) {
        this.body.append("start_date", val.startDate);
      }

      if (val.endDate) {
        this.body.append("end_date", val.endDate);
      }

      if (val.status === "استشاري قائم") {
        this.body.append("status", 1);
      }

      if (val.status === "استشاري مؤرشف") {
        this.body.append("status", 0);
      }

      if (val.range) {
        this.body.append("range", val.range);
      }

      if (val.managerId.length) {
        const managerProperties = {};

        val.managerId.forEach((item, index) => {
          this.body.append([`manager_id[${index}]`], item.id);
        });
      }

      if (val.agentId.length) {
        const managerProperties = {};

        val.agentId.forEach((item, index) => {
          this.body.append([`adviser_id[${index}]`], item.id);
        });
      }

      if (val.dayNumber) {
        this.body.append("range", val.dayNumber);
      }

      if (val.collaborator_id.length) {
        console.log('this is collaborator_id')
        console.log(val.collaborator_id)
        val.collaborator_id.forEach((item, index) => {
          this.body.append([`collaborator_id[${index}]`], item.collaborator_id);
        });
      }


      this.getTableData(1, "getDataDone");
    },

    setTbData(items) {
      this.$store.state.tableData.push({
        id: items.id,
        "استشاري المبيعات": items.name,
        "سرعة الاتصال بعد طلب الخدمة": items.q1 + " %",
        "تقديم الحسبة المبدئية للعميل": items.q2 + " %",
        "المتابعة مع العميل": items.q3 + " %",
        "صحة ملاحظة الاستشاري": items.q4 + " %",
        "النتيجة النهائية": items.result + " %",
      });
    },

    getTableData(count) {
      this.$store.state.tableData = [];
      this.loading = true;
      Axios.post(
        `${this.$store.state.url}/employee/admin/quality-survey-chart`,this.body,
        {
          headers: this.request_headers(),
        }
      ).then((res) => {
        res.data.payload.map((item) => {
          this.setTbData(item);
        });

        this.$store.state.pagination = {
          limit: 3,
          count: res.data.payload.length,
        };

        this.drawChart(res.data.payload);
        this.loading = false;
      });
    },

    drawChart(data) {

      // redraw chart 
      this.chartData = [];
      this.chartOptions.xAxis.categories = [];
      this.chartOptions.series[0].data = [];

      this.chartData = data;
      this.horizontalData = this.chartData.map((item) => item.name);
      this.verticalData = this.chartData.map((item) => item.result);
      this.chartOptions.xAxis.categories = this.horizontalData;
      this.chartOptions.series[0].data = this.verticalData;
    
      this.loading = false;
    },

    exportsToExcel() {
      const table = document.querySelector(".requests-chart-classification table");
      this.exportTableToCsv(table, this.$route.name);
    },
  },

  created() {
    this.$store.state.tableData = [];
  },
};
</script>
